var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"default"},[_c('Head'),_vm._t("default"),_c('Foot'),_c('CPopForm'),_c('PopWarning')],2)
}
var staticRenderFns = []

export { render, staticRenderFns }